// extracted by mini-css-extract-plugin
export default {"recos":"x2-z","productCardOverride":"y2-z","rowHasBadge":"z2-z"};